import React from 'react';
import ReactHtml from 'components/shared/ReactHtml';

export const Image = ({ data }) => {
  if (!data || !data.contentImagePresent) return null;

  return (
    <>
      <article>
        <div className="media">
          <a href={data.viewUrl} data-behavior="lightbox">
            <img src={data.viewUrl} alt="Lesson creator uploaded content" />
          </a>

          <a
            href={data.viewUrl}
            className="mobile_img"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={data.viewUrl}
              alt="Lesson creator mobile uploaded content"
            />
          </a>
        </div>

        {data.caption && (
          <figcaption>
            <ReactHtml>{data.caption}</ReactHtml>
          </figcaption>
        )}
      </article>
    </>
  );
};

Image.propTypes = {};

export default Image;
